export default "__VITE_ASSET__CUg9Psma__"